module.exports = __webpack_public_path__ + "img/jquery.2ae04f81.svg";